module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff3427a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/audienceHub/AudienceHub.vue
// module id = 2011
// module chunks = 0